module.exports = __webpack_public_path__ + "img/app-showcase-base.ebe135b3.png";